/* tslint:disable */

declare var Object: any;
export interface CalendarServiceInterface {
  "id"?: number;
}

export class CalendarService implements CalendarServiceInterface {
  "id": number;
  constructor(data?: CalendarServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CalendarService`.
   */
  public static getModelName() {
    return "CalendarService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CalendarService for dynamic purposes.
  **/
  public static factory(data: CalendarServiceInterface): CalendarService{
    return new CalendarService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CalendarService',
      plural: 'CalendarServices',
      path: 'CalendarServices',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/CalendarService.ts